/* SENTINEL_MARKER_MDO_2026_04_21 — used to verify push reaches CDN */
if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.formInput = this.form?.querySelector("[name=id]");
        if (this.formInput) this.formInput.disabled = false;
        this.form?.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart = document.querySelector("cart-drawer");
        this.cartType = this.cart?.dataset.cartType || "page";

        this.submitButton = this.querySelector('[type="submit"]');
        this.body = document.querySelector("body");

        if (document.querySelector("cart-drawer"))
          this.submitButton?.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";

        this.handleErrorMessage = this.handleErrorMessage.bind(this);
        this.redirectAfterSubmit = this.redirectAfterSubmit.bind(this);
        this.disableLoadingInButton = this.disableLoadingInButton.bind(this);
      }

      closeComplementaryProduct() {
        const complementaryOverlayPage = document.querySelector(
          ".wt__quick-buy--page-overlay",
        );
        if (this.body.classList.contains("quick-buy-page-overlay"))
          this.body.classList.remove("quick-buy-page-overlay");
        if (
          complementaryOverlayPage.classList.contains(
            "wt__quick-buy--page-overlay--open",
          )
        )
          complementaryOverlayPage.classList.remove(
            "wt__quick-buy--page-overlay--open",
          );
      }

      getFormLinkedElement(selector) {
        return (
          Array.from(this.ownerDocument.querySelectorAll(selector)).find(
            (element) => element.form === this.form,
          ) || null
        );
      }

      async uploadPrescriptionFile() {
        const fileInput = this.getFormLinkedElement(
          "[data-prescription-file-input]",
        );
        if (!fileInput || !fileInput.files || fileInput.files.length === 0) {
          console.log("[prescription-upload] no file → skipping upload, returning null");
          return null;
        }

        const file = fileInput.files[0];
        console.log("[prescription-upload] start", {
          name: file.name,
          size: file.size,
          type: file.type,
        });
        const maxSize = 10 * 1024 * 1024;
        if (file.size > maxSize) {
          throw new Error("File is too large. Maximum size is 10 MB.");
        }

        const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];
        const fileName = (file.name || "").toLowerCase();
        const allowedExtensions = [".jpg", ".jpeg", ".png", ".pdf"];
        const hasAllowedType = allowedTypes.includes((file.type || "").toLowerCase());
        const hasAllowedExtension = allowedExtensions.some((extension) =>
          fileName.endsWith(extension),
        );

        if (!hasAllowedType && !hasAllowedExtension) {
          throw new Error("Invalid file type. Please upload a JPEG, PNG, or PDF.");
        }

        const variantId = this.form.querySelector("[name=id]")?.value || "";
        const productTitle =
          document.querySelector(".product__title h1")?.textContent?.trim() ||
          document.title ||
          "";

        const formData = new FormData();
        formData.append("prescription_file", file);
        formData.append("variantId", String(variantId));
        formData.append("productTitle", productTitle);

        const honeypot = this.getFormLinkedElement('input[name="website"]');
        if (honeypot) {
          formData.append("website", honeypot.value);
        }

        const t0 = performance.now();
        const response = await fetch(
          "https://app.marcosdiveoptics.com/api/prescription/upload",
          {
            method: "POST",
            body: formData,
          },
        );
        const elapsed = Math.round(performance.now() - t0);
        console.log(
          `[prescription-upload] response status=${response.status} in ${elapsed}ms`,
        );

        let data = null;
        try {
          data = await response.json();
        } catch (error) {
          data = null;
        }

        if (!response.ok || !data?.success || !data?.prescriptionId) {
          console.error("[prescription-upload] FAILED", { status: response.status, data });
          throw new Error(
            data?.message || "Prescription upload failed. Please try again.",
          );
        }

        console.log("[prescription-upload] success, prescriptionId=", data.prescriptionId);
        return data.prescriptionId;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();
        this.cart?.setActiveElement(document.activeElement);

        const loader = this.querySelector(".loading-overlay__spinner");

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        if (loader) loader.classList.remove("hidden");

        const hiddenInput = this.getFormLinkedElement(
          "[data-prescription-id-input]",
        );
        if (hiddenInput) hiddenInput.value = "";

        // Snapshot upsell selection at click time so it survives the async upload wait
        const upsellCardAtSubmit = document.querySelector(
          "[data-upsell-card].wt-upsell__card--selected",
        );
        this._pendingUpsell = upsellCardAtSubmit
          ? {
              variantId:
                upsellCardAtSubmit.getAttribute("data-upsell-variant-id") ||
                null,
              price:
                upsellCardAtSubmit.getAttribute("data-upsell-price") || null,
            }
          : null;
        console.log("[add-to-cart] submit clicked", {
          hasFile: !!(
            this.getFormLinkedElement("[data-prescription-file-input]") &&
            this.getFormLinkedElement("[data-prescription-file-input]").files
              ?.length
          ),
          upsellAtSubmit: this._pendingUpsell,
        });

        this.uploadPrescriptionFile()
          .then((prescriptionId) => {
            if (prescriptionId && hiddenInput) hiddenInput.value = prescriptionId;
            console.log(
              "[add-to-cart] upload settled, prescriptionId=",
              prescriptionId,
              "→ calling _addToCart",
            );
            return this._addToCart();
          })
          .catch((uploadError) => {
            console.error("Prescription upload error:", uploadError);
            this.handleErrorMessage(
              uploadError.message ||
                "Prescription upload failed. Please try again.",
            );
            this.submitButton.removeAttribute("aria-disabled");
            this.submitButton.classList.remove("loading");
            if (loader) loader.classList.add("hidden");
          });
      }

      _addToCart() {
        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        formData.delete("website");
        if (!formData.get("properties[_prescription_id]")) {
          formData.delete("properties[_prescription_id]");
        }

        this._flattenPrescriptionProperties(formData);

        if (this.cart && typeof this.cart.getSectionsToRender === "function") {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id),
          );
        } else {
          formData.append("sections", []);
        }

        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        console.log("[add-to-cart] POST /cart/add (main)", {
          id: formData.get("id"),
          quantity: formData.get("quantity"),
          prescription_id: formData.get("properties[_prescription_id]"),
          lens_thickness: formData.get("properties[Lens Thickness]"),
        });

        return fetch(`${routes.cart_add_url}`, config)
          .then((response) => {
            console.log(
              `[add-to-cart] main /cart/add response status=${response.status} redirected=${response.redirected} url=${response.url}`,
            );
            return response.json();
          })
          .then((response) => {
            if (response.status) {
              console.error("[add-to-cart] main cart/add returned error", response);
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.error = true;

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");

              this.dispatchEvent(
                new CustomEvent("cart-drawer:refresh", {
                  detail: { response: response },
                  bubbles: true,
                  composed: true,
                }),
              );

              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            /* ── Add upsell product as separate cart line item ── */
            // Prefer the selection captured at submit time (survives async upload
            // wait), fall back to a fresh DOM query for the safety net.
            const upsellCardNow = document.querySelector(
              "[data-upsell-card].wt-upsell__card--selected",
            );
            const upsellVid =
              (this._pendingUpsell && this._pendingUpsell.variantId) ||
              (upsellCardNow
                ? upsellCardNow.getAttribute("data-upsell-variant-id")
                : null);
            console.log("[add-to-cart] upsell resolution", {
              fromSnapshot: this._pendingUpsell,
              fromDomNow: upsellCardNow
                ? upsellCardNow.getAttribute("data-upsell-variant-id")
                : null,
              chosen: upsellVid,
            });

            const finishCartAdd = (cartResponse) => {
              if (!this.error) {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  cartData: cartResponse,
                });
                console.info("[product-form] cart add success → dispatching lens:reset");
                document.dispatchEvent(new CustomEvent("lens:reset", { bubbles: true }));
              }

              this.error = false;
              const quickAddModal = this.closest("quick-add-modal");
              if (quickAddModal) {
                document.body.addEventListener(
                  "modalClosed",
                  () => {
                    setTimeout(() => {
                      this.redirectAfterSubmit(cartResponse);
                    });
                  },
                  { once: true },
                );
                if (this.cartType === "drawer") quickAddModal.hide(true);
              } else {
                const isClosedCart = !document.body.classList.contains(
                  "page-overlay-cart-on",
                );
                this.redirectAfterSubmit(cartResponse, isClosedCart);
              }
            };

            if (upsellVid) {
              const qty = parseInt(formData.get("quantity"), 10) || 1;
              const parentId = formData.get("id") || "";

              const upsellFormData = new FormData();
              upsellFormData.append("id", upsellVid);
              upsellFormData.append("quantity", String(qty));
              upsellFormData.append(
                "properties[_parent_product]",
                String(parentId),
              );

              // Ask Shopify to render the cart sections with the CURRENT cart
              // state (main + upsell) so the cart drawer can re-render cleanly.
              if (
                this.cart &&
                typeof this.cart.getSectionsToRender === "function"
              ) {
                upsellFormData.append(
                  "sections",
                  this.cart
                    .getSectionsToRender()
                    .map((section) => section.id)
                    .join(","),
                );
                upsellFormData.append("sections_url", window.location.pathname);
              }

              const upsellConfig = fetchConfig("javascript");
              upsellConfig.headers["X-Requested-With"] = "XMLHttpRequest";
              delete upsellConfig.headers["Content-Type"];
              upsellConfig.body = upsellFormData;

              console.log("[add-to-cart] POST /cart/add (upsell)", {
                id: upsellVid,
                quantity: qty,
                parentId: parentId,
              });

              return fetch(`${routes.cart_add_url}`, upsellConfig)
                .then((r) => {
                  console.log(
                    `[add-to-cart] upsell /cart/add response status=${r.status} redirected=${r.redirected} url=${r.url}`,
                  );
                  return r.json();
                })
                .then((upsellResponse) => {
                  console.log("[add-to-cart] upsell response body", upsellResponse);
                  if (upsellResponse && upsellResponse.status) {
                    console.error("Upsell add failed:", upsellResponse);
                    publish(PUB_SUB_EVENTS.cartError, {
                      source: "product-form-upsell",
                      productVariantId: upsellVid,
                      errors:
                        upsellResponse.errors || upsellResponse.description,
                      message: upsellResponse.message,
                    });
                    finishCartAdd(response);
                  } else {
                    console.log("[add-to-cart] upsell added OK ✓");
                    finishCartAdd(upsellResponse);
                  }
                })
                .catch((err) => {
                  console.error("Upsell add threw:", err);
                  finishCartAdd(response);
                });
            } else {
              console.warn(
                "[add-to-cart] no upsellVid → skipping upsell /cart/add. This is the bug symptom if you expected an upsell.",
              );
            }

            finishCartAdd(response);
          })
          .catch((e) => {
            console.error(e);
            if (e instanceof TypeError && e.message.includes("'cart-drawer'")) {
              location.reload();
            }
          })
          .finally(() => {
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            this.submitButton.removeAttribute("aria-disabled");
            if (this.error) {
              this.disableLoadingInButton();
              return;
            }
            this.quick_add_container = document.querySelector(
              ".wt__quick-buy__container",
            );
            this.quick_add_overlay = document.querySelector(
              ".wt__quick-buy--page-overlay",
            );
            this.quick_add_product =
              this.quick_add_container.querySelector(".wt-product");
            this.loader = this.quick_add_container.querySelector(
              ".wt__quick-buy-loader",
            );

            if (!this.quick_add_container.classList.contains("hidden")) {
              // use handle and quickbuy closeCart()

              this.quick_add_product?.remove();
              this.quick_add_container.classList.remove(
                "wt__quick-buy__container--open",
              );
              this.quick_add_overlay.classList.remove(
                "wt__quick-buy--page-overlay--open",
              );
              document.body.classList.remove("quick-buy-page-overlay");
              this.loader.classList.remove("hidden");
            }

            // delay button loading
            setTimeout(() => {
              this.disableLoadingInButton();
            }, 200);
          });
      }

      disableLoadingInButton() {
        this.submitButton.classList.remove("loading");
        this.querySelector(".loading-overlay__spinner").classList.add("hidden");
      }

      /**
       * Replace nested prescription line-item properties
       * (e.g. properties[Your Prescription | FAR distance][SPH][Right])
       * with a single flat property holding a per-eye human-readable summary.
       *
       * Without this, Shopify stores the nested hash and renders it in the
       * admin as a Ruby literal `{"SPH" => {"Right" => "..."}, ...}`.
       */
      _flattenPrescriptionProperties(formData) {
        const nestedPattern = /^properties\[Your Prescription \| ([^\]]+)\]\[([^\]]+)\]\[([^\]]+)\]$/;
        const valuesByEye = {};
        const keysToDelete = [];
        let lensLabel = "";
        let anyValue = false;

        for (const key of Array.from(formData.keys())) {
          const match = key.match(nestedPattern);
          if (!match) continue;
          lensLabel = match[1];
          const field = match[2];
          const eye = match[3];
          const val = (formData.get(key) || "").toString().trim();
          if (val) anyValue = true;
          if (!valuesByEye[eye]) valuesByEye[eye] = {};
          valuesByEye[eye][field] = val;
          keysToDelete.push(key);
        }

        if (keysToDelete.length === 0) return;
        keysToDelete.forEach((k) => formData.delete(k));

        const hasFile = !!formData.get("properties[_prescription_id]");
        let summary = "";

        if (!anyValue && hasFile) {
          summary = "Uploaded prescription";
        } else if (anyValue) {
          const fieldOrder = ["SPH", "CYL", "AXIS", "ADD"];
          const lines = [];
          ["Right", "Left"].forEach((eye) => {
            const values = valuesByEye[eye] || {};
            const parts = [];
            fieldOrder.forEach((field) => {
              const v = (values[field] || "").trim();
              if (!v || v === "No CYL" || v === "No AXIS") return;
              const display = field === "AXIS" ? v + "°" : v;
              parts.push(field + " " + display);
            });
            if (parts.length > 0) lines.push(eye + ": " + parts.join(" / "));
          });
          summary = lines.join("\n");
        }

        if (summary) {
          const propName = lensLabel
            ? `properties[Your Prescription | ${lensLabel}]`
            : "properties[Your Prescription]";
          formData.append(propName, summary);
        }
      }

      redirectAfterSubmit(response, isClosedCart = true) {
        const body = document.body;
        const isCartPage = body.classList.contains("template-cart");

        if (this.cartType === "drawer" && isCartPage) {
          const overlay = document.querySelector(
            ".wt__quick-buy--page-overlay",
          );
          overlay.classList.remove("wt__quick-buy--page-overlay--open");
          body.classList.remove("quick-buy-page-overlay");
        } else if (this.cartType === "drawer") {
          this.cart.renderContents(response, isClosedCart);
          return;
        }
        window.location = window.routes.cart_url;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}
